<template>
  <div>
    <b-card no-body>
      <b-row>
        <b-col cols="12">
          <b-row class="pb-1 mt-50">
            <!-- <b-col cols="5" class="text-left">
              <b-button variant="primary" @click="New()" class="btn-sm mr-50 ml-50">
                <feather-icon icon="PlusIcon" size="16" class="align-text-top" />
                Thêm mới
              </b-button>
              <b-button variant="primary" @click="Deletes()" class="btn-sm">
                <feather-icon icon="DeleteIcon" size="16" class="align-text-top" />
                Xóa
              </b-button>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col cols="12">
              <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [20, 50, 100], dropdownAllowAll: false }"
                              :rows="items" :select-options="{ enabled: true }"
                              :totalRows="totalRecords"
                              mode="remote" @on-page-change="onPageChange"
                              @on-sort-change="onSortChange"
                              @on-column-filter="onColumnFilter"
                              @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectionChanged">
                <template slot="table-row" slot-scope="props">
                  <!-- Column: Action -->
                  <span v-if="props.column.field === 'action'">
                    <span>
                      <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                        <feather-icon icon="Edit2Icon"/>
                      </b-button>
                    </span>
                  </span>
                </template>
              </vue-good-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="modal-edit" size="xl" title="Cập nhật nội dung" @ok="handleOk">
      <b-row>
        <b-col cols="6">
          <b-form-group>
            <label>Tên</label>
            <b-form-input v-model="currentItem.name" placeholder="Tên sản phẩm khám phá" type="text"/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <label>Nhà cung cấp</label>
            <b-form-input v-model="currentItem.vendor" placeholder="Nhà cung cấp" type="text"/>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group>
            <label>Liên kết <span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.link" :state="validateState('link')" placeholder="Linh liên kết tới chuyên mục" required
                          type="text"/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <label>Ảnh đại diện<span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.image_url" :state="validateState('image_url')"
                          placeholder="Link ảnh (hoặc đường dẫn ảnh thuộc thư mục gốc assets/images trên trang sản phẩm)"
                          required
                          type="text"/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <label>Thứ tự<span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.sort_order" :state="validateState('sort_order')" placeholder="Thứ tự hiển thị" required
                          type="number"/>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <ckeditor v-model="currentItem.description" :config="editorConfig" :editor-url="editorUrl" class="editor-form"
                    placeholder="Nội dung"></ckeditor>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import {NewGroupType} from '@/@core/utils/utils';
import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor, {
  toolbar: [],
  toolbarGroups: [],
  placeholder: 'Nội dung chính'
});

export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend,
    BFormFile
  },
  methods: {
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },
    loadItems() {
      try {
        this.loading(true);
        this.serverParams.columnFilters.type = NewGroupType.POLICY;
        let data = {
          ...this.serverParams,
          columnFilters: {
            ...(this.serverParams.columnFilters ? this.serverParams.columnFilters : [])
          }
        }

        useJwt
            .post("baseus-admin/getProductdiscover", data)
            .then((response) => {
              this.items = response.data.result;
              this.totalRecords = response.data.totalRecords;
              this.isLoading = false;
              this.loading(false);
            });
      } catch (ex) {
        this.loading(false);
      }
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật sản phâm khám phá";
      this.$bvModal.show("modal-edit");
    },


    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.isSubmit = true;
      const bIsValid = await this.isValidPo(this.currentItem);
      if (!bIsValid) {
        return;
      }

      const url = `baseus-admin/productdiscover/${this.currentItem.id}`;
      const updateParams = {
        id: this.currentItem.id,
        name: this.currentItem.name,
        vendor: this.currentItem.vendor,
        status: this.currentItem.status,
        link: this.currentItem.link,
        description: this.currentItem.description,
        image_url: this.currentItem.image_url,
        sort_order: this.currentItem.sort_order
      };
      try {
        this.loading(true);
        const res = await useJwt.put(url, updateParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.loadItems();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập nhật thành công!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.$bvModal.hide("modal-edit");

        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi cập nhật sản phẩm ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });

      }

    },
    async isValidPo(item) {
      if (!item.name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    },

    async quickSearch() {
      this.loadItems();
    },
    catOnChange(e) {
      this.topicList = this.topicAll.filter(function (item) {
        return item.parent_id == e
      });
    }
  },
  mounted() {
    this.isSubmit = false;
    this.loadItems();
  },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      items: [],
      categoryList: [],
      topicList: [],
      topicAll: [],
      departmentList: [],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {},
      rowSelection: [],
      options: {
        fields: [
          {field: "action", label: "Thao tác", width: "120px"},
          {
            field: "name",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Tên chính sách",
            required: true
          },
          {
            field: "vendor",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nhà cung cấp",
            required: true
          },
          {
            field: "description",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nội dung",
            required: true
          },
          {
            field: "link",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Link",
            required: true
          },

          {
            field: "image_url",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Đường dẫn ảnh",
            required: true
          },
          {
            field: "sort_order",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Thứ tự",
            required: true
          }
        ]
      },
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 20,
        "lang": 1
      },
      editorUrl: 'https://cdn.ckeditor.com/4.20.0/full-all/ckeditor.js',
      editorConfig: {
        extraPlugins: 'tableresize',
        toolbarGroups: [
          {name: 'document', groups: ['mode', 'document', 'doctools']},
          {name: 'clipboard', groups: ['clipboard', 'undo']},
          {name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
          {name: 'forms', groups: ['forms']},
          {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
          {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
          {name: 'links', groups: ['links']},
          {name: 'insert', groups: ['insert']},
          {name: 'styles', groups: ['styles']},
          {name: 'colors', groups: ['colors']},
          {name: 'tools', groups: ['tools']},
          {name: 'others', groups: ['others']},
          {name: 'about', groups: ['about']}
        ]
      }
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
.readonly {
  pointer-events: none;
  touch-action: none;

  .select2-selection {
    background: #eee;
    box-shadow: none;
  }

  .select2-selection__arrow,
  .select2-selection__clear {
    display: none;
  }
}


.vgt-table td,
.vgt-table th {
  max-width: 500px;
}
</style>
